export default "__VITE_ASSET__d3807093__"